import { render } from "./LeavePersonal.vue?vue&type=template&id=947cb284&scoped=true"
import script from "./LeavePersonal.vue?vue&type=script&lang=js"
export * from "./LeavePersonal.vue?vue&type=script&lang=js"

import "./LeavePersonal.vue?vue&type=style&index=0&id=947cb284&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947cb284"]])

export default __exports__